import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Key } from 'lucide-react';
import { API_BASE_URL } from '../global';
import { showAlert } from '../components/AlertPopup';
import './Auth.css';

export default function Login() {
  const navigate = useNavigate();
  const [step, setStep] = useState('EMAIL'); // EMAIL, PASSWORD, CODE, CREATE_PASSWORD
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleCheckEmail = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/auth.php?action=check_email`, {
        method: 'POST',
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (data.success) {
        if (data.has_password) {
          setStep('PASSWORD');
        } else {
          // Exibe o código gerado num alerta para teste, conforme solicitado
          showAlert('Aviso de Sistema', `O código de acesso temporário foi gerado: ${data.generated_code}. Use-o para criar sua senha.`);
          setStep('CODE');
        }
      } else {
        showAlert('Erro', data.error || 'Acesso não autorizado');
      }
    } catch (e) {
      showAlert('Erro', 'Erro de conexão');
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/auth.php?action=login`, {
        method: 'POST',
        body: JSON.stringify({ email, senha: password })
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem('userId', data.user.id);
        navigate('/dashboard');
      } else {
        showAlert('Erro', data.error || 'Senha incorreta');
      }
    } catch (e) {
      showAlert('Erro', 'Erro de conexão');
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/auth.php?action=verify_code`, {
        method: 'POST',
        body: JSON.stringify({ email, codigo: code })
      });
      const data = await res.json();
      if (data.success) {
        setStep('CREATE_PASSWORD');
      } else {
        showAlert('Erro', data.error || 'Código inválido');
      }
    } catch (e) {
      showAlert('Erro', 'Erro de conexão');
    }
  };

  const handleCreatePassword = async (e) => {
    e.preventDefault();
    if (!newPassword || newPassword.length < 6) {
      showAlert('Aviso', 'A senha deve ter pelo menos 6 caracteres');
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/auth.php?action=create_password`, {
        method: 'POST',
        body: JSON.stringify({ email, codigo: code, nova_senha: newPassword })
      });
      const data = await res.json();
      if (data.success) {
        showAlert('Sucesso', 'Senha criada com sucesso! Faça login.');
        setStep('PASSWORD');
      } else {
        showAlert('Erro', data.error || 'Erro ao criar senha');
      }
    } catch (e) {
      showAlert('Erro', 'Erro de conexão');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card slide-up">
        <div className="auth-header">
          <div className="auth-logo">A</div>
          <h2>Alefolia</h2>
          <p>
            {step === 'EMAIL' && 'Identifique-se para acessar'}
            {step === 'PASSWORD' && 'Insira sua senha'}
            {step === 'CODE' && 'Insira o código de validação'}
            {step === 'CREATE_PASSWORD' && 'Crie sua senha de acesso'}
          </p>
        </div>
        
        {step === 'EMAIL' && (
          <form onSubmit={handleCheckEmail} className="auth-form">
            <div className="form-group">
              <label>E-mail corporativo</label>
              <div className="input-with-icon">
                <Mail size={18} className="input-icon" />
                <input type="email" placeholder="seu@email.com" required value={email} onChange={e => setEmail(e.target.value)} />
              </div>
            </div>
            <button type="submit" className="btn-primary auth-submit">Avançar</button>
          </form>
        )}

        {step === 'PASSWORD' && (
          <form onSubmit={handleLogin} className="auth-form">
            <div className="form-group">
              <label>E-mail</label>
              <div className="input-with-icon">
                <Mail size={18} className="input-icon" />
                <input type="email" value={email} disabled />
              </div>
            </div>
            <div className="form-group">
              <label>Senha</label>
              <div className="input-with-icon">
                <Lock size={18} className="input-icon" />
                <input type="password" placeholder="••••••••" required value={password} onChange={e => setPassword(e.target.value)} autoFocus />
              </div>
            </div>
            <button type="submit" className="btn-primary auth-submit">Entrar</button>
            <div style={{marginTop: '1rem', textAlign: 'center'}}>
              <button type="button" className="text-link" onClick={() => setStep('EMAIL')}>Voltar</button>
            </div>
          </form>
        )}

        {step === 'CODE' && (
          <form onSubmit={handleVerifyCode} className="auth-form">
            <div className="form-group">
              <label>Código de Acesso</label>
              <div className="input-with-icon">
                <Key size={18} className="input-icon" />
                <input type="text" placeholder="000000" required value={code} onChange={e => setCode(e.target.value)} autoFocus />
              </div>
              <small style={{color: 'var(--text-muted)'}}>Consulte o código recebido.</small>
            </div>
            <button type="submit" className="btn-primary auth-submit">Validar Código</button>
            <div style={{marginTop: '1rem', textAlign: 'center'}}>
              <button type="button" className="text-link" onClick={() => setStep('EMAIL')}>Voltar</button>
            </div>
          </form>
        )}

        {step === 'CREATE_PASSWORD' && (
          <form onSubmit={handleCreatePassword} className="auth-form">
            <div className="form-group">
              <label>Nova Senha</label>
              <div className="input-with-icon">
                <Lock size={18} className="input-icon" />
                <input type="password" placeholder="Mínimo 6 caracteres" required value={newPassword} onChange={e => setNewPassword(e.target.value)} autoFocus />
              </div>
            </div>
            <button type="submit" className="btn-primary auth-submit">Criar Senha e Acessar</button>
          </form>
        )}
      </div>
    </div>
  );
}
